export const formatComments = (peopleComment?: string, comment?: string) => {
    if (peopleComment && comment) {
        return `${peopleComment} - ${comment}`;
    }
    return peopleComment || comment;
}

export const renderCellWithEllipsis = (value: string) => {
    const MAX_LENGTH = 40;
    return value && value?.length > MAX_LENGTH
        ? `${value.substring(0, MAX_LENGTH)}...`
        : value
};

